export default {
  SET_ACCOUNTS(state, accounts) {
    state.accounts = accounts
  },
  REMOVE_ACCOUNT(state, itemId) {
      const accountIndex = state.accounts.datas.findIndex((u) => u.id == itemId)
      state.accounts.datas.splice(accountIndex, 1)
  },
  SELECTED_ACCOUNT(state,data){
    state.accounts.datas = []
    state.accounts.total = 1;
    state.accounts.per_page = 1;
    state.accounts.datas.push(data)
  },
  SET_PHONE_TYPES(state,phone_types){
    state.phone_types = phone_types
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  SET_VERTICALS(state,data){
    state.verticals = data
  },
  SET_COUNTRIES(state,data){
    state.countries = data
  },
  SET_SIC_CODES(state,data){
    state.sic_codes = data
  },
  SET_PHONE_CODES(state,data){
    state.phone_codes = data
  },
  SET_COMPANY_OR_REGISTRATION_NO(state,data){
    state.company_or_registration_no = data
  }
}
